import * as React from 'react';
import cn from 'classnames';
import { GdAdditionalParameterFragment } from '@websky/graphql';
import { Field } from '../../../../Passenger/components/Field/Field';
import { InputType } from '../../../../Passenger/types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';

interface Props {
	fields: GdAdditionalParameterFragment[];
	passengerId: number;
	segmentId: number;
}

const GROUPS = [
	{
		name: 'Pet info',
		fields: ['type', 'weight']
	},
	{
		name: 'Dimensions of transportation',
		fields: ['length', 'width', 'height']
	}
];

const PassengerForm: React.FC<Props> = props => {
	const { t } = useTranslation('Checkout');
	const theme = useTheme('CheckoutAdditionalService').PassengerForm;

	const groups = React.useMemo(() => {
		return GROUPS.map(group => {
			return {
				name: t(group.name),
				fields: group.fields.map(fieldName => props.fields.find(field => field.name === fieldName))
			};
		});
	}, [props.fields, t]);

	return (
		<div>
			{groups.map(group => (
				<div className={theme.group} key={group.name}>
					<div className={theme.group__name}>{group.name}</div>

					<div className={theme.group__fields}>
						{group.fields.map(field => (
							<Field
								className={cn(theme.field, { [theme.field_select]: field.name === 'type' })}
								key={field.name}
								field={{
									type: null,
									name: `passengers[${props.passengerId}].[${props.segmentId}].${field.name}`,
									input: field.name === 'type' ? InputType.Select : InputType.Text,
									validations: field.validationRules,
									placeholder: t(`pet_${field.name}`)
								}}
								passengerId={props.passengerId}
								passengerType={null}
								translateSelectOption={true}
								menuProps={{ disablePortal: true }}
							/>
						))}
					</div>
				</div>
			))}
		</div>
	);
};

export default PassengerForm;
